import React from 'react';
import BeaconMetricSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconMetricSplineChart';
import useKeywordSearchRequestBuilder from './useKeywordSearchRequestBuilder';
import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';

/**
 * Ad clicks spline chart on the keywords search page
 */
export default function KeywordAdClicksSpline({
  builderFunction
}: {
  builderFunction?: (
    additionalBuilder?: (builder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder
  ) => (requestBuilder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder;
}) {
  const keywordSearchRequestBuilder = useKeywordSearchRequestBuilder('advertising');
  const builderToUse = builderFunction || keywordSearchRequestBuilder;
  return (
    <BeaconMetricSplineChart
      indexName="advertising"
      fieldName="clicks"
      requestBuilder={builderToUse((builder) => {
        // Ad clicks uses different terms for keywords
        return builder
          .replaceConditionTermFilterFieldName('searchTermFuzzy', 'searchKeywordFuzzy')
          .replaceConditionTermFilterFieldName('excludedSearchTerm', 'excludedSearchKeyword')
          .replaceConditionTermFilterFieldName('excludedSearchTermFuzzy', 'excludedSearchKeywordFuzzy')
          .replaceConditionTermFilterFieldName('searchTerm', 'searchKeyword');
      })}
    />
  );
}
